import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
interface CancelCommitteeModalProps {
  committeeName: string;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}
export function CancelCommitteeModal({
  committeeName,
  onCancel,
  onConfirm
}: CancelCommitteeModalProps) {
  const [reason, setReason] = useState('');
  const [reasonError, setReasonError] = useState(false);
  const handleSubmit = () => {
    if (!reason.trim()) {
      setReasonError(true);
      return;
    }
    onConfirm(reason);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-343">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4" data-id="element-344">
        <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-345">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-346">
            Cancel Committee
          </h3>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-500" data-id="element-347">
            <X size={20} data-id="element-348" />
          </button>
        </div>
        <div className="p-6" data-id="element-349">
          <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-6" data-id="element-350">
            <div className="flex" data-id="element-351">
              <div className="flex-shrink-0" data-id="element-352">
                <AlertTriangle className="h-5 w-5 text-red-400" data-id="element-353" />
              </div>
              <div className="ml-3" data-id="element-354">
                <h3 className="text-sm font-medium text-red-800" data-id="element-355">
                  Warning: This action cannot be undone
                </h3>
                <div className="mt-2 text-sm text-red-700" data-id="element-356">
                  <p data-id="element-357">
                    You are about to cancel the committee "{committeeName}".
                    This will archive the committee and all its associated data.
                    The committee will no longer be active in the system.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-6" data-id="element-358">
            <label htmlFor="cancellation-reason" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-359">
              Cancellation Reason <span className="text-red-500" data-id="element-360">*</span>
            </label>
            <textarea id="cancellation-reason" rows={4} className={`w-full px-3 py-2 border ${reasonError ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500`} placeholder="Please provide a detailed reason for cancelling this committee..." value={reason} onChange={e => {
            setReason(e.target.value);
            if (e.target.value.trim()) setReasonError(false);
          }} data-id="element-361"></textarea>
            {reasonError && <p className="mt-1 text-sm text-red-600" data-id="element-362">
                Cancellation reason is required
              </p>}
          </div>
          <div className="flex justify-end space-x-3" data-id="element-363">
            <button type="button" className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" onClick={onCancel} data-id="element-364">
              Cancel
            </button>
            <button type="button" className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors" onClick={handleSubmit} data-id="element-365">
              Confirm Cancellation
            </button>
          </div>
        </div>
      </div>
    </div>;
}